import { createSelector } from '@ngrx/store';
import { getDragonflySharedState } from '../../reducers';

export const getLiteralsState = createSelector(getDragonflySharedState, (state) => state.literals);

export const getInvoiceNumber = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoices.filters.invoicenumber'],
);

export const getLoyaltyCard = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoices.filters.invoicecard'],
);

export const getDateFrom = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoices.filters.datefrom'],
);

export const getDateUntil = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoices.filters.dateuntil'],
);

export const getStore = createSelector(getLiteralsState, ({ literals }) => literals['liquid.invoice.store']);

export const getInvoiceDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.invoices.invoice_date'],
);

export const getGrandTotal = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.search.sort.invoices.grand_total'],
);

export const getDescending = createSelector(getLiteralsState, ({ literals }) => literals['liquid.search.sort.desc']);

export const getAscending = createSelector(getLiteralsState, ({ literals }) => literals['liquid.search.sort.asc']);

export const getCreationDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.invoice.creationdate'],
);

export const getGridInvoiceDate = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.invoice.invoicedate'],
);

export const getInvoiceTime = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.invoice.invoicetime'],
);

export const getGridInvoiceNumber = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.invoice.invoicenumber'],
);

export const getGridGrandTotal = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.invoice.grandtotal'],
);

export const getLineAmount = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.invoiceline.lineamount'],
);

export const getReturnPurchase = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoice.returnpurchase'],
);

export const getRemarks = createSelector(getLiteralsState, ({ literals }) => literals['liquid.invoice.remarks']);

export const getReturn = createSelector(getLiteralsState, ({ literals }) => literals['liquid.invoice.return']);

export const getPurchase = createSelector(getLiteralsState, ({ literals }) => literals['liquid.invoice.purchase']);

export const getGrandTotalTooltip = createSelector(getLiteralsState, ({ literals }) => literals['invoice.grandtotal']);

export const getAmountTooltip = createSelector(getLiteralsState, ({ literals }) => literals['invoice.total']);

export const getLineItem = createSelector(getLiteralsState, ({ literals }) => literals['liquid.invoice.lineitem']);

export const getCoupons = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoices.coupons.header'],
);

export const getAttributes = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoices.attributes.header'],
);

export const getProductNumber = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.invoiceline.productnumber'],
);

export const getLineDescription = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.invoiceline.linedescription'],
);

export const getQuantity = createSelector(getLiteralsState, ({ literals }) => literals['system.invoiceline.quantity']);

export const getUnitPrice = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoice.invoiceline.unitprice'],
);

export const getDiscount = createSelector(
  getLiteralsState,
  ({ literals }) => literals['system.invoiceline.discountamount'],
);

export const getAmount = createSelector(getLiteralsState, ({ literals }) => literals['system.invoiceline.lineamount']);

export const getCouponsetId = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoices.coupons.couponset'],
);

export const getCouponCode = createSelector(
  getLiteralsState,
  ({ literals }) => literals['liquid.invoices.coupons.couponcode'],
);
